<script lang="ts">
	import DefaultButton from '../../../basic/buttons/DefaultButton.svelte';
	import { _ } from 'svelte-i18n';

	interface Props {
		backupCode: string;
		onModalClose: () => void;
	}

	let { onModalClose, backupCode }: Props = $props();

	let printUsed: boolean = $state(false);

	function handlePrintOnlyCodeView() {
		const iframe = document.createElement('iframe');
		iframe.style.display = 'none';
		document.body.appendChild(iframe);
		const pri = iframe.contentWindow;

		if (pri) {
			pri.document.open();
			pri.document.writeln(
				`<p>${$_('settings.admin.two_factor_auth.lbl_backup_code_explained')}</p>`
			);
			pri.document.writeln(`<p style="color:red;">${backupCode}</p>`);
			pri.document.close();
			pri.focus();
			pri.print();
			pri.onafterprint = () => {
				document.body.removeChild(iframe);
			};
		}

		printUsed = true;
	}
</script>

<div class="flex flex-col gap-2">
	<p class="text-center font-bold">{$_('settings.admin.two_factor_auth.lbl_setup_done')}</p>

	<p class="text-center" style="max-width: 720px;">
		{$_('settings.admin.two_factor_auth.lbl_backup_code_explained')}
	</p>
	<!--Backup code-->
	<p class="text-center text-xl text-red dark:text-orange">{backupCode}</p>

	<!--Buttons-->
	<div class="flex gap-2 justify-end">
		<!--Print-->
		<DefaultButton
			onClick={handlePrintOnlyCodeView}
			secondary={printUsed}
			text={$_('settings.admin.two_factor_auth.bt_print')}
		/>
		<!--Close button-->
		<DefaultButton
			disabled={!printUsed}
			onClick={() => {
				onModalClose();
			}}
			text={$_('general.bt_close')}
		/>
	</div>
</div>
